interface NoticeItem {
  title?: string;
  read: boolean;
  message: any;
  time: string;
}
interface NoticeState {
  notices: NoticeItem[];
  noticeMessage?: string | number;
  chatMessage?: string | number;
}
export const useNoticeStore = defineStore('notice', () => {
  const state = reactive<NoticeState>({
    notices: [],
    noticeMessage: '',
    chatMessage: ''
  });

  const addNotice = (notice: NoticeItem) => {
    state.notices.push(notice);
  };
  // 添加站内信数量
  const addNoticeMessage = (noticeMessage?: string | number) => {
    state.noticeMessage = noticeMessage;
  };
  // 添加chat消息数量
  const addChatMessage = (chatMessage?: string | number) => {
    state.chatMessage = chatMessage;
  };
  const removeNotice = (notice: NoticeItem) => {
    state.notices.splice(state.notices.indexOf(notice), 1);
  };

  //实现全部已读
  const readAll = () => {
    state.notices.forEach((item: any) => {
      item.read = true;
    });
  };

  const clearNotice = () => {
    state.notices = [];
  };
  return {
    state,
    addNotice,
    addNoticeMessage,
    addChatMessage,
    removeNotice,
    readAll,
    clearNotice
  };
});

export default useNoticeStore;
